/*
  语言切换时同步 <head> 与 <html lang>。

  中文根页与英文 /en/ 各有静态 HTML。客户端切换语言时仍要同步 title / description /
  og / canonical / lang，避免 SPA 重新渲染后 head 还停在上一门语言。

  文案来自 content.mjs，与静态 HTML、JSON-LD 同一份，不另写。
*/
import { CONTENT, contentFor, SITE, urlFor } from './content.mjs'

function setMeta(attr, key, value) {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, key)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', value)
}

/**
 * @param {string} locale vue-i18n 的 locale（'zh' / 'en'）
 */
export function applyHead(locale) {
  const code = locale === 'en' ? 'en' : 'zh'
  const copy = contentFor(code)
  const htmlLang = code === 'en' ? 'en' : 'zh-CN'
  const pageUrl = urlFor(code)

  document.title = copy.title
  document.documentElement.setAttribute('lang', htmlLang)

  setMeta('name', 'description', copy.description)
  setMeta('property', 'og:title', copy.title)
  setMeta('property', 'og:description', copy.description)
  setMeta('property', 'og:url', pageUrl)
  setMeta('property', 'og:locale', htmlLang === 'en' ? 'en_US' : 'zh_CN')
  /* alternate 要写「另一种语言」，中文页面配 en_US、英文页面配 zh_CN */
  setMeta('property', 'og:locale:alternate', htmlLang === 'en' ? 'zh_CN' : 'en_US')
  setMeta('name', 'twitter:title', copy.title)
  setMeta('name', 'twitter:description', copy.description)

  /* 英文页面必须 canonical 到英文地址。停在中英文共用的首页会告诉搜索引擎
     这份英文内容是中文页面的重复版本，把 hreflang 的收益抵消掉。 */
  const canonical = document.head.querySelector('link[rel="canonical"]')
  if (canonical) canonical.setAttribute('href', pageUrl)
}

/**
 * 把地址栏对齐到独立的语言路径（用 replaceState，不新增历史记录）。
 * `/en/` 是真实生成的静态页，刷新时服务器不需要执行 JS 也能返回英文内容。
 */
export function syncLangParam(locale) {
  if (typeof window === 'undefined' || !window.history || !window.history.replaceState) return
  const url = new URL(window.location.href)
  url.pathname = locale === SITE.defaultLocale ? '/' : '/en/'
  /* 兼容旧链接；新规范不再把语言塞进查询串。 */
  url.searchParams.delete('lang')
  const next = `${url.pathname}${url.search}${url.hash}`
  if (next !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
    window.history.replaceState(null, '', next)
  }
}

export { CONTENT }
